import React, {Component} from 'react';
import {Button, Col, Form, Input, message, Row, Select} from 'antd';

import {connect} from 'react-redux';
import {queryAccountList} from '@api/core/user';

import SelectOrg from '@comm/SelectOrg';

const FormItem = Form.Item;
const { Option } = Select;

class Index extends Component {
  constructor(props) {
    super(props);
    this.state = {
      accountList: [],
      orgUuid: '',
    };
  }

  componentDidMount() {
    this.loadAccount();
  }

  submit = e => {
    e.preventDefault();
    const data = this.props.form.getFieldsValue();
    data.orgUuid = this.state.orgUuid;
    this.props.search(data);
  };

  onChangeOrg = value => {
    this.setState({
      orgUuid: value,
    });
    this.loadAccount(value);
    this.props.form.setFieldsValue({ userUuid: '' });
  };

  /**
   *获取用户列表
   */
  loadAccount = orgUuid => {
    const uuid = orgUuid || '';
    queryAccountList({ orgUuid: uuid }).then(res => {
      if (res.statusCode === 200) {
        this.setState({
          accountList: res.data,
        });
      } else {
        message.error(res.message);
      }
    });
  };

  reset = e => {
    e.preventDefault();
    this.props.form.resetFields();
    this.setState({
      orgUuid: undefined,
    });
    const data = this.props.form.getFieldsValue();
    this.props.search(data);
  };

  render() {
    const { getFieldDecorator } = this.props.form;
    const formItemLayout = {
      labelCol: { span: 8 },
      wrapperCol: { span: 16 },
    };
    const { accountList } = this.state;
    return (
      <Form className="search-form" layout="horizontal" onSubmit={this.submit}>
        <Row type="flex">
          <Col span={6}>
            <FormItem {...formItemLayout} label="客户名称">
              {getFieldDecorator('name')(<Input />)}
            </FormItem>
          </Col>
          <Col span={8}>
            <FormItem label="保护人部门" {...formItemLayout}>
              <SelectOrg
                onChange={this.onChangeOrg}
                orgUuid={this.state.orgUuid}
                placeholder="保护人部门"
              />
            </FormItem>
          </Col>
          <Col span={6}>
            <FormItem label="保护人" {...formItemLayout}>
              {getFieldDecorator('userUuid', {
                rules: [{ message: '姓名不能为空！' }],
              })(
                <Select
                  showSearch
                  optionFilterProp="children"
                  placeholder="保护人姓名"
                  filterOption={(input, option) =>
                    option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                  }
                >
                  {accountList.map(item => {
                    return <Option key={item.uuid}>{item.name}</Option>;
                  })}
                </Select>,
              )}
            </FormItem>
          </Col>
          <Col span={4}>
            <FormItem>
              <Row type="flex" justify="end">
                <Button type="primary" htmlType="submit" style={{ marginRight: '10px' }}>
                  搜索
                </Button>
                <Button onClick={this.reset} style={{ marginRight: '10px' }}>
                  重置
                </Button>
              </Row>
            </FormItem>
          </Col>
        </Row>
      </Form>
    );
  }
}

export default connect(state => state)(Form.create()(Index));



// WEBPACK FOOTER //
// ./src/components/xianxing/protect/FormSearch.js